<template>

<!-- Galeria de Screenshots -->
<section class="screenshots">
    
    <div class="carousel">
      <div 
        v-for="(image, index) in screenshots" 
        :key="index" 
        class="carousel-item"
        :class="{ active: activeImage === index }"
      >
        <img :src="image" :alt="'Captura de tela ' + (index + 1)">
      </div>
      <div class="carousel-controls">
        <button @click="prevImage" class="control-btn">❮</button>
        <button @click="nextImage" class="control-btn">❯</button>
      </div>
    </div>
  </section>
  <div class="game-page">
    <!-- Seção Hero -->

    <section class="hero-section">
      <div class="hero-content">
        <h1>Turbo Tatu - O Jogo</h1>
      <p>Bem-vindo ao <strong>Turbo Tatu</strong>, o jogo mais empolgante de corrida e aventura! Junte-se ao nosso herói, o Tatu Turbo, enquanto ele corre através de florestas, montanhas e cavernas, enfrentando obstáculos e coletando itens para alcançar a linha de chegada!</p>
      
        <div class="cta-container">
          <a href="https://play.google.com/store/apps/details?id=com.aaapp.TurboTatu" class="download-cta" target="_blank" rel="noopener noreferrer">
            <img src="../assets/google-play-badge.png" alt="Disponível no Google Play">
          </a>
        </div>
      </div>
      <div class="hero-media">
        <img src="../assets/turboTatu.png" alt="Dino em ação" class="hero-image">
      </div>
    </section>

    <!-- Carrossel de Gameplay -->
    <section class="media-carousel">
      <h2 class="section-title">Imersão Selvagem</h2>
      <div class="carousel-wrapper">
        <div class="carousel-inner" :style="{ transform: `translateX(-${activeImage * 100}%)` }">
          <div 
            v-for="(image, index) in screenshots" 
            :key="index" 
            class="carousel-item"
          >
            <img :src="image" :alt="`Cena do jogo ${index + 1}`" class="carousel-image">
          </div>
        </div>
        <div class="carousel-controls">
          <button @click="prevImage" class="carousel-button prev">‹</button>
          <button @click="nextImage" class="carousel-button next">›</button>
        </div>
      </div>
    </section>

    <!-- Mecânicas Principais -->
    <section class="core-features">
      <h2 class="section-title">Sistema de Jogo Inovador</h2>
      <div class="feature-grid">
     
     
     
        <div class="feature-card">
          <div class="feature-icon">⚔️</div>
          <h3>objetivos</h3>
          <p>
            O objetivo é superar todos os desafios e chegar ao final das fases, colecionando pontos e desbloqueando novos níveis de dificuldade.
          </p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">🌿</div>
          <h3>Ecosistema Vivo</h3>
          <p>
            Colete vidar e prolongue sua jornada:
          </p>
          <ul class="power-list">
            <li>• Velocidade Alfa - Turbo de curta duração</li>
            <li>• Salte por obstáculos</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Progressão do Jogador -->
    <section class="progression-system">
      <h2 class="section-title">Sua Evolução</h2>
      <div class="progression-steps">
        <div class="progression-card">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Domínio Básico</h3>
            <p>Aprenda os controles fluidos com tutorial integrado e mecanismos de assistência adaptativa</p>
          </div>
        </div>

        <div class="progression-card">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Estratégia Avançada</h3>
            <p>Desbloqueie combos de disparo e técnicas de esquiva com temporização precisa</p>
          </div>
        </div>

        <div class="progression-card">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Maestria Total</h3>
            <p>Desafie modos hardcore com condições climáticas dinâmicas e padrões de ataque aleatórios</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Chamada Final -->
    <section class="final-cta">
      <div class="cta-content">
        <h2>Pronto para a Corrida Definitiva?</h2>
        <p>Junte-se à comunidade de 500k+ jogadores em 15 idiomas!</p>
        <div class="download-badges">
          <a href="#" class="store-link">
            <img src="../assets/google-play-badge.png" alt="Google Play">
          </a>
        </div>
      </div>
    </section>
  </div>


  <div class="privacy-section">
        <button @click="togglePrivacyPolicy" class="toggle-button">
          {{ showPrivacyPolicy ? 'Ocultar' : 'Mostrar' }} Política de Privacidade
          <span class="arrow" :class="{ 'up': showPrivacyPolicy }">▼</span>
        </button>
        
        <transition name="slide">
        <iframe 
                v-if="showPrivacyPolicy"
                :src="privacyPolicyContent"
                class="privacy-iframe"
                frameborder="0"
            ></iframe>
        </transition>
      </div>


</template>



<script>
export default {
  name: 'DinoDashPage',
  data() {
    return {
      activeImage: 0,
      screenshots: [
        require('@/assets/screenshots/screen1.jpg'),
        require('@/assets/screenshots/screen2.jpg'),
        require('@/assets/screenshots/screen3.jpg')
        
      ],
      showPrivacyPolicy: false,
      privacyPolicyContent: `data:text/html;charset=utf-8,${encodeURIComponent(`
       <!DOCTYPE html>
<html lang="pt-br">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Política de Privacidade - Turbo Tatu</title>
  <style>
    .privacy-policy {
      font-family: Arial, sans-serif;
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
    }

    h1 {
      color: #333;
    }

    h2 {
      color: #555;
    }

    a {
      color: #4CAF50;
    }
  </style>
</head>
<body>
  <div class="privacy-policy">
    <h1>Política de Privacidade</h1>
    <p>Bem-vindo à nossa Política de Privacidade. No <strong>Turbo Tatu</strong>, respeitamos a privacidade dos nossos usuários e estamos comprometidos em proteger suas informações pessoais.</p>

    <h2>Informações que Coletamos</h2>
    <p>Coletamos informações pessoais que você nos fornece diretamente, como nome, e-mail e dados de uso do jogo.</p>

    <h2>Como Usamos as Informações</h2>
    <p>As informações que coletamos são usadas para melhorar a experiência do usuário, enviar atualizações sobre o jogo, e oferecer suporte ao cliente.</p>

    <h2>Dados de Menores de 13 Anos</h2>
    <p>Se o nosso público-alvo incluir crianças menores de 13 anos, garantiremos que coletamos dados de maneira responsável e em conformidade com as leis de privacidade de crianças.</p>

    <h2>Compartilhamento de Dados</h2>
    <p>Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprir as leis ou regulamentações.</p>

    <h2>Links para Terceiros</h2>
    <p>Este jogo pode conter links para sites de terceiros. Não somos responsáveis pelas práticas de privacidade desses sites.</p>

    <h2>Alterações na Política de Privacidade</h2>
    <p>Podemos atualizar esta política de privacidade de tempos em tempos. Qualquer mudança será publicada nesta página com a data da última atualização.</p>

    <h2>Entre em Contato</h2>
    <p>Se você tiver alguma dúvida sobre esta política, entre em contato conosco em <a href="mailto:aleappdev@gmail.com">aleappdev@gmail.com</a>.</p>
  </div>
</body>
</html>

      `)}`

    }
  },
  methods: {
    nextImage() {
      this.activeImage = (this.activeImage + 1) % this.screenshots.length
    },
    prevImage() {
      this.activeImage = (this.activeImage - 1 + this.screenshots.length) % this.screenshots.length
    },
    togglePrivacyPolicy() {
        this.showPrivacyPolicy = !this.showPrivacyPolicy
      }
  }
}
</script>

<style scoped>
.screenshots {
  margin: 4rem 0;
}

.carousel {
  position: relative;
  max-width: 800px;
  margin: 2rem auto;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.carousel-item {
  display: none;
  transition: opacity 0.5s ease;
}

.carousel-item.active {
  display: block;
}

.carousel-item img {
  width: 100%;
  height: auto;
}

.carousel-controls {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
}

.control-btn {
  background: rgba(255,255,255,0.8);
  border: none;
  padding: 1rem;
  cursor: pointer;
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.control-btn:hover {
  background: rgba(255,255,255,1);
}

.feature-comparison {
  background: #f8f9fa;
  padding: 4rem 0;
}

.comparison-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 2rem auto;
}

.comparison-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.comparison-card.competitor {
  background: #fff5f5;
}

.comparison-card ul {
  list-style: none;
  padding: 0;
}

.comparison-card li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}


/* Estilos Base */
.game-page {
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.section-title {
  font-size: 2.2rem;
  color: #2E7D32;
  text-align: center;
  margin: 3rem 0 2rem;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 3px;
  background: #FFD54F;
  margin: 0.5rem auto;
}

/* Hero Section */
.hero-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  padding: 4rem 0;
}

.hero-content h1 {
  font-size: 2.8rem;
  color: #1B5E20;
  line-height: 1.2;
  margin-bottom: 1.5rem;
}

.subtitle {
  font-size: 1.8rem;
  color: #388E3C;
  font-weight: 500;
  margin-bottom: 1.2rem;
}

.hero-description {
  font-size: 1.1rem;
  color: #424242;
  line-height: 1.8;
  margin-bottom: 2rem;
}

.hero-image {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

/* Carrossel */
.media-carousel {
  margin: 4rem 0;
}

.carousel-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 15px;
}

.carousel-inner {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  min-width: 100%;
}

.carousel-image {
  width: 100%;
  height: 500px;
  object-fit: cover;
}

.carousel-controls {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  padding: 0 1rem;
}

.carousel-button {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-button:hover {
  background: rgba(255, 255, 255, 1);
  transform: scale(1.1);
}

/* Features */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
}

.feature-card {
  background: #F1F8E9;
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid #C8E6C9;
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.power-list {
  list-style: none;
  padding-left: 0;
  margin-top: 1rem;
}

.power-list li {
  padding: 0.3rem 0;
  font-size: 0.95rem;
  color: #616161;
}

/* Progressão */
.progression-steps {
  display: grid;
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
}

.progression-card {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  background: #E8F5E9;
  padding: 1.5rem;
  border-radius: 10px;
}

.step-number {
  background: #2E7D32;
  color: white;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* Responsividade */
@media (max-width: 768px) {
  .hero-section {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .carousel-image {
    height: 300px;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }
}


.privacy-section {
    margin-top: 30px;
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
  
  .toggle-button {
    background: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
  }
  
  .toggle-button:hover {
    background: #45a049;
  }
  
  .arrow {
    display: inline-block;
    transition: transform 0.3s;
    margin-left: 10px;
  }
  
  .arrow.up {
    transform: rotate(180deg);
  }
  
  .privacy-iframe {
    width: 100%;
    height: 500px;
    margin-top: 15px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .slide-enter-active, .slide-leave-active {
    transition: all 0.5s ease;
    max-height: 600px;
    overflow: hidden;
  }
  
  .slide-enter-from, .slide-leave-to {
    max-height: 0;
    opacity: 0;
  }
</style>